<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <lawn-estimate-details
            v-if='estimate'
            :estimate='estimate'
            :estimateDetail='estimate.estimate_detail'
            @update='updateEstimate'
          ></lawn-estimate-details>
        </v-col>
        <v-col cols='12' md='4'>
          <lot-rating
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
            @updateDetail='updateDetail'
          ></lot-rating>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4'>
          <site-address
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></site-address>
        </v-col>
        <v-col cols='12' md='4'>
          <contacts
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></contacts>
        </v-col>
        <v-col cols='12' md='4'>
          <invoicing-notes
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></invoicing-notes>
        </v-col>
      </v-row>

        <wc-page-section class='mt-n7' title='Files'></wc-page-section>

        <v-row>
          <v-col cols='12' md='12'>
            <estimate-files
              class='mt-6'
              v-if="estimate"
              :files='estimate.estimate_file_data'
              :estimate_id='estimate.id'
              :disabled='estimate.is_sold'
            ></estimate-files>
          </v-col>
        </v-row>

      <wc-page-section class='mt-n7' title='Instructions & Details'></wc-page-section>
      <v-row>
        <v-col cols='12' md='4'>
          <spring-cleanup-instructions
            v-if='estimate'
            :estimate='estimate'
            @updateDetail='updateDetail'
          ></spring-cleanup-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <lawn-care-instructions
            v-if='estimate'
            :estimate='estimate'
            @updateDetail='updateDetail'
          ></lawn-care-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <fertilizer-instructions
            v-if='estimate'
            :estimate='estimate'
            @updateDetail='updateDetail'
          ></fertilizer-instructions>
        </v-col>
        <v-col cols='12'>
          <lawn-details
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
            @updateDetail='updateDetail'
          ></lawn-details>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/estimates/components/Basics';
import Details from '@/modules/estimates/components/lawn/Details';
import SiteAddress from '@/modules/estimates/components/SiteAddress';
import LotRating from '@/modules/estimates/components/lawn/LotRating';
import Contacts from '@/modules/estimates/components/Contacts';
import SpringCleanupInstructions from '@/modules/estimates/components/lawn/SpringCleanupInstructions';
import LawnCareInstructions from '@/modules/estimates/components/lawn/LawnCareInstructions';
import FertilizerInstructions from '@/modules/estimates/components/lawn/FertilizerInstructions';
import InvoicingNotes from '@/modules/estimates/components/InvoicingNotes';
import EstimateFiles from '@/components/files/EstimateFiles';
import LawnDetails from '@/modules/estimates/components/lawn/LawnDetails';
import estimatesAPI from '@/modules/estimates/api/estimates';
import estimateLinesAPI from '@/modules/estimates/api/estimateLineItems';

export default {
  name: 'lawn-estimate-overview',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isSavingLine: false,
    lines: [],
  }),
  computed: {
    subtitle () {
      if (this.estimate.site_address) {
        return this.estimate.site_address
      } else {
        return ""
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.lines =  await estimateLinesAPI.getEstimateLineItems(this.estimate.id)
      this.isLoading = false
    },
    async updateEstimate (estimate) {
      this.$emit('update', estimate)
    },
    async updateDetail (estimateDetail) {
      this.estimate.estimate_detail = await estimatesAPI.updateLawnEstimate(estimateDetail)
    }
  },
  components: {
    'basics': Basics,
    'lawn-estimate-details': Details,
    'site-address': SiteAddress,
    'lot-rating': LotRating,
    'contacts': Contacts,
    'invoicing-notes': InvoicingNotes,
    'spring-cleanup-instructions': SpringCleanupInstructions,
    'lawn-care-instructions': LawnCareInstructions,
    'fertilizer-instructions': FertilizerInstructions,
    'lawn-details': LawnDetails,
    'estimate-files': EstimateFiles,
  }
}
</script>